import styled from 'styled-components';
import React, { FC } from 'react';
import { white } from '../../utils/styles';
import { BODY_WIDTH } from './';
import { rhythm } from '../../utils/typography';

export type SectionProps = { color?: string };

export const SectionWrap = styled.div<SectionProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ color }) => color};
`;

export const SectionBody = styled.div`
  width: 100%;
  max-width: ${BODY_WIDTH};
  padding: 0 ${rhythm(1)};
  overflow: hidden;
`;

export const Section: FC<SectionProps> = ({ color = white, children, ...rest }) => (
  <SectionWrap color={color} {...rest}>
    <SectionBody>{children}</SectionBody>
  </SectionWrap>
);
